import Box from "@mui/material/Box";
import PersonIcon from "@mui/icons-material/Person";

export default function Matches({ matchedRSVPs, onSelect = () => {} }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <h2>Please select your party</h2>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "60%",
          flexWrap: "wrap",
          "@media (max-width:600px)": {
            width: "80%",
          },
        }}
      >
        {matchedRSVPs.map((party) => {
          const names = Object.keys(party.rsvp).map(
            (guestID) => party.rsvp[guestID].name,
          );
          return (
            <Box
              key={party.id}
              onClick={() => onSelect(party)}
              sx={{
                display: "flex",
                flexDirection: "column",
                color: "rgb(80, 97, 117)", // text color
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "rgb(80, 97, 117)", // default border
                borderRadius: "4px",
                padding: "1rem",
                margin: "1rem",
                "&:hover": {
                  borderColor: "rgb(64, 80, 97)", // hover border
                  backgroundColor: "rgb(230, 230, 213)", // 10% darker hover background
                  cursor: "pointer",
                },
              }}
            >
              {names.map((name) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <PersonIcon
                    fontSize="small"
                    sx={{ color: "rgb(80, 97, 117)", mr: 1 }}
                  />
                  {name === "" ? "+1" : name}
                </Box>
              ))}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
